/* eslint-disable */
import session from './session';

export default {
    getOrderList(filter) {
        return session.get(`order${filter}`);
    },
    getOrder(id) {
        return session.get(`order/${id}/`);
    },
    deleteOrder(orderId) {
        return session.delete(`order/${orderId}/`);
    },
    createOrder(data) {
        return session.post(`order/`, data);
    },
    updateOrderData(orderId, data) {
        return session.patch(`order/${orderId}/`, data );
    },
    resolveOrder(orderId, data) {
        return session.post(`order/${orderId}/resolve/`, data);
    },
}; 